<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .keypad-action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-radius: 2rem;
    cursor: pointer;
    border: none;
    outline: none;

    &:hover {
      opacity: 0.8;
    }

    &.decline {
      background-color: colors.get(systemError_100);
    }

    &.accept {
      background-color: colors.get(primary_50);
    }

    .icon {
      font-size: utils.in_rem(18px);
      color: colors.get(textWhite);
    }
  }
</style>

<script>
  const { type = "accept", onClick, rotation = 0 } = $props();
</script>

<button
  class="keypad-action-button {type}"
  onclick={onClick}
  aria-label="Keypad action button"
>
  <i class="fa-solid fa-phone icon" style="transform: rotate({rotation}deg);"
  ></i>
</button>
